import React from 'react';
//Para Documentacion
import PropTypes from 'prop-types';
//MUI
import Dialog, {DialogProps} from '@mui/material/Dialog';
export interface DialogBaseProps extends DialogProps {
   disableBackdropClick?: boolean;
   disableEscapeKeyDown?: boolean;
   containerId?: string;
}
interface PartialDialogProps {
   open: boolean;
   onClose: (e: {}, reason: 'backdropClick' | 'escapeKeyDown') => boolean | undefined;
   style?: object;
   BackdropProps?: any;
   container?: HTMLElement | null;
}
/**
 * <p>Contenedor con comportamiento modal para envolver cualquier tipo de contenido.</p>
 * Cualquier otra propiedad proporcionada sera controlada por el elemento raiz [Dialog de Material-UI](https://material-ui.com/api/dialog/)
 */
const DialogBase: React.FC<DialogBaseProps> = (props) => {
   const {containerId, open, onClose, disableBackdropClick, disableEscapeKeyDown, ...other} = props;
   function handleOnClose(e: {}, reason: 'backdropClick' | 'escapeKeyDown') {
      if (disableBackdropClick && reason === 'backdropClick') {
         return false;
      }

      if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
         return false;
      }

      if (typeof onClose === 'function') {
         onClose(e, reason);
      }
   }

   let dialogProps: PartialDialogProps = {
      open: open,
      onClose: handleOnClose
   };

   if (containerId) {
      dialogProps.style = {position: 'absolute'};
      dialogProps.BackdropProps = {style: {position: 'absolute'}};
      dialogProps.container = document.getElementById(containerId);
   }

   return (
      <Dialog {...other} {...dialogProps} aria-labelledby="form-dialog">
         {props.children}
      </Dialog>
   );
};

DialogBase.propTypes = {
   /**
    * Si es true el modal se encuentra abierto.
    */
   open: PropTypes.bool.isRequired,
   /**
    * Función a ejecutar cuando se cierra el modal.
    */
   onClose: PropTypes.func,
   /**
    * Elementos a renderizar dentro del modal.
    * Todos los elementos entre los tags de DialogBase son pasados automaticamente en la propiedad children.
    */
   children: PropTypes.node,
   /**
    * Indica el id del contenedor sobre el que el modal se abrira.
    */
   containerId: PropTypes.string,
   /**
    * Si es __true__ no se ejecutara el callback `onClose` cuando se haga click fuera del modal.
    */
   disableBackdropClick: PropTypes.bool,
   /**
    * Si es __true__ no se ejecutara el callback `onClose` cuando se presione la tecla *escape*.
    */
   disableEscapeKeyDown: PropTypes.bool
};

export default DialogBase;
